export default __webpack_public_path__ + "static/media/home-marketing-agency-bg-img-07.b2149502.jpg";